import { useCallback, useEffect, useMemo, useState } from 'react';
import { DateTime } from 'luxon';
import { Text } from '@mantine/core';

export default function WorkOrderLiveHours({
  inAt,
  plus,
  estimate,
}: {
  inAt: string;
  plus?: number;
  estimate: number | null;
}) {
  const inAtDate = useMemo(
    () => DateTime.fromISO(inAt, { zone: 'UTC' }),
    [inAt],
  );

  const [hours, setHours] = useState(0);

  const refresh = useCallback(() => {
    const now = DateTime.utc();
    const hours = now.diff(inAtDate, 'hours').hours;
    setHours(hours + (plus ?? 0));
  }, [inAtDate, plus]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    refresh();
    // Set up an interval to update state every 1000ms (1 second)
    const timerId = setInterval(() => {
      refresh();
    }, 60000);

    // Clean up the interval on unmount to prevent memory leaks
    return () => clearInterval(timerId);
  }, []);

  if (estimate === null) {
    return (
      <Text size="sm" fw={600}>
        {hours.toFixed(2)}
      </Text>
    );
  }

  const hoursDiff = estimate - hours;
  const color = hoursDiff < 0 ? 'red' : hoursDiff <= 0.5 ? 'yellow' : 'green';

  return (
    <Text size="sm" fw={600} c={color}>
      {`${hours.toFixed(2)} / ${estimate.toFixed(2)}`}
    </Text>
  );
}
